import { atom, appJotaiStore } from "../app-jotai";

import type { CurrentCloudDoc } from "./types";

const STORAGE_KEY = "excalidraw-cloud-current-doc";

const load = (): CurrentCloudDoc | null => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as CurrentCloudDoc) : null;
  } catch {
    return null;
  }
};

/** The open drawing's association with a cloud document (survives reloads). */
export const currentCloudDocAtom = atom<CurrentCloudDoc | null>(load());

export const getCurrentCloudDoc = (): CurrentCloudDoc | null =>
  appJotaiStore.get(currentCloudDocAtom);

export const setCurrentCloudDoc = (doc: CurrentCloudDoc | null): void => {
  appJotaiStore.set(currentCloudDocAtom, doc);
  try {
    if (doc) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(doc));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore storage errors
  }
};
